import React from 'react';

import { WarehouseDocuments } from '../../components/WarehouseDocuments';

export const Shipments: React.FC = () => <WarehouseDocuments kind="shipment" />;
